import Vue from 'vue'
import VueTruncate from 'vue-truncate-filter'

Vue.use(VueTruncate)
